import { EditorView } from '@codemirror/view'

/** Chrome styling to match the developers quickstart panel. */
export function developerCodeMirrorChrome(isDark: boolean) {
  return EditorView.theme(
    {
      '&': {
        backgroundColor: 'transparent',
        fontSize: '12px',
        height: '100%',
      },
      '&.cm-focused': {
        outline: 'none',
      },
      '.cm-scroller': {
        overflow: 'auto',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
        lineHeight: '1.5',
        height: '100%',
      },
      '.cm-content': {
        padding: '16px 48px 40px 0',
        caretColor: 'transparent',
        minHeight: '100%',
      },
      '.cm-gutters': {
        backgroundColor: 'transparent',
        borderRight: isDark ? '0.5px solid oklch(0.329 0.002 106)' : '0.5px solid var(--color-line-subtle, #E8E4DC)',
        color: isDark ? 'oklch(0.520 0.003 308)' : 'var(--color-meta-5, #9B9690)',
      },
      '.cm-lineNumbers .cm-gutterElement': {
        padding: '0 12px 0 16px',
        minWidth: '32px',
      },
      '.cm-activeLineGutter': {
        backgroundColor: 'transparent',
      },
      '.cm-activeLine': {
        backgroundColor: 'transparent',
      },
      '.cm-selectionBackground, &.cm-focused .cm-selectionBackground, ::selection': {
        backgroundColor: isDark ? 'oklch(0.300 0.035 160 / 0.45)' : 'oklch(0.930 0.040 160 / 0.55)',
      },
    },
    { dark: isDark },
  )
}
